var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, -16.000000) translate(0.000000, 15.000000) translate(2.000000, 2.000000)",
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.88,
    d: "M12.296 12.252L15.964 15.92"
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 0.88,
    cx: 7.04,
    cy: 7.084,
    r: 7.004
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.472,11.804 C5.87234806,11.9772572 4.29673924,11.3115947 3.30586333,10.0438923 C2.31498742,8.77618993 2.04954676,7.08645887 2.604,5.576",
    strokeWidth: 0.76
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchblack);
export default __webpack_public_path__ + "static/media/Search black.7870809c2eed3a3b3f06f46503cc8a6b.svg";
export { ForwardRef as ReactComponent };